import {Values} from '@wix/devzai-utils-common';

export const WixAppRuntimeEnvironment = {
    Local: 'local',
    Staging: 'staging',
    Production: 'production'
} as const;

export type WixAppRuntimeEnvironment = Values<typeof WixAppRuntimeEnvironment>;


export namespace WixAppRuntimeEnvironment {
    export type NonProduction = Exclude<WixAppRuntimeEnvironment, typeof WixAppRuntimeEnvironment.Production>;

    export type NonLocal = Exclude<WixAppRuntimeEnvironment, typeof WixAppRuntimeEnvironment.Local>;

    export type StagingOnly = Extract<WixAppRuntimeEnvironment, typeof WixAppRuntimeEnvironment.Staging>;

}